<template>
  <section class="record" @click="goPrescriptionDetail(medicalRecord)">
    <div class="record__info">
      <h1 class="over-ellip record-title">
        {{medicalRecord.advisoryResult}}
      </h1>
      <p class="mb10">
        <span class="record__label">就诊医生</span>
        <span class="record__content">{{medicalRecord.doctorName}}</span>
      </p>
      <p class="mb10">
        <span class="record__label">就诊科室</span>
        <span class="record__content">{{medicalRecord.departmentName}}</span>
      </p>
      <p>
        <span class="record__label">就诊时间</span>
        <span class="record__content">{{medicalRecord.advisoryTime | parseDate}}</span>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    medicalRecord: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      STATUS_MAP: { EXPIRED: 'EXPIRED' }
    };
  },
  methods: {
    // eslint-disable-next-line class-methods-use-this
    goPrescriptionDetail({ recordsId }) {
      this.$router.push({
        path: '/record-view',
        query: { recordsId }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@black-5: #595959; //次要文字
@black-2: #262626; //加醋文字
@font-size-sm: 12px;
@font-size-md: 14px;
@font-size-lg: 18px;
.record {
  background-color: white;
  font-size: @font-size-md;
  margin-bottom: 10px;
  border-radius: 8px;

  &__info {
    position: relative;
    padding: 0 16px 16px 16px;
    background: #fff;
    color: #595959;
    border-radius: 8px;
    .over-ellip {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .record-title{
      font-size: 16px;
      font-weight: bold;
      color: @black-2;
      padding: 16px 0;
      border-bottom: 1px solid #eee;
      margin-bottom: 12px;
    }
    .record__label{
      color: @black-5;
      margin-right: 8px;
    }
    .record__content{
      color: @black-2;
    }
  }
  .mb10{
    margin-bottom: 10px;
  }
}
</style>
